import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import RibbonBg from 'assets/images/instant-booking-ribbon.svg';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${themeGet('color.25', '#495e6e')};
  padding: 30px 30px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin-bottom: 0;
    font-size: 14px;
    color: ${themeGet('color.1', '#ffffff')};
  }
`;

export const RibbonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 43px;
  width: 286px;
  background-image: url(${({ bgSrc }) => bgSrc || RibbonBg});
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 4px;
  .anticon {
    color: ${themeGet('color.1', '#ffffff')};
    margin-bottom: 10px;
    margin-right: 7px;
  }
`;

export const Title = styled.h5`
  color: ${themeGet('color.1', '#ffffff')};
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 13px;
`;
